import { List, ListItem } from "@mui/material";

import InjuryForm from "./InjuryForm";

export default function LatestInjurySummary({ injury, casePk }) {
  if (!injury) {
    return <p className="text-center">Something went wrong</p>;
  }

  return (
    <>
      <h2 className="pb-1 text-center text-[1.2rem] font-bold">Pain Level</h2>
      {injury?.createdBy && (
        <List className="pt-0 text-[12px]">
          <ListItem className="justify-center p-0">
            Updated at: {new Date(injury.createdAt).toLocaleString()}
          </ListItem>
          <ListItem className="justify-center p-0">
            Updated by: {injury?.createdBy?.name ?? "Unknown"}
          </ListItem>
        </List>
      )}
      <div>
        <InjuryForm injury={injury} casePk={casePk} />
      </div>
    </>
  );
}
